import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Card } from './card';
import { ErrorState } from './empty-state';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/**
 * Last line of defence. A render crash in one screen must not leave the
 * operator looking at a blank page with no way to tell what happened.
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Console render error', error, info.componentStack);
  }

  override render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <Card>
        <ErrorState
          title="This screen stopped working"
          message={error.message}
          onRetry={() => this.setState({ error: null })}
        />
      </Card>
    );
  }
}
